import React from 'react';

export default function Header() {
  return (
    <header className="app-header">
      <span className="header-title">AI Prototyping Guide</span>
      <div className="header-right">
        <span className="header-team">Last updated by the Savvy Design team on Feb 23, 9:18 AM EST</span>
      </div>
    </header>
  );
}
